import { Component } from "react";
import PropTypes from "prop-types";
import { buildStaticDocUrl } from "./../../../services/util";

/**
 * A link to a legal document.
 */
export default class LegalLink extends Component {
  render() {
    return (
      <a
        href={buildStaticDocUrl(this.props.language, this.props.documentUrl)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {this.props.label}
      </a>
    );
  }
}

LegalLink.propTypes = {
  /** A label of a link. */
  label: PropTypes.object.isRequired,
  /** A url to a legal document (place where it's stored). */
  documentUrl: PropTypes.string.isRequired,
  /**
   * A current language (default language of the browser or selected by user).
   * It is a [language tag](https://www.w3.org/International/articles/language-tags/) like 'en' for English.
   */
  language: PropTypes.string,
};
